import {
  Box,
  ButtonLink,
  Column,
  Columns,
  Heading,
  Inline,
  Stack,
  Text,
} from 'braid-design-system';

import Routes from 'src/config/routes';
import { createDotNetLinkUrl } from 'src/utils';

import supportImage from './packagesPageImages/support.jpg';

import * as styles from './SupportMessage.css';

export const SupportMessage = () => (
  <Box width="full" data={{ testid: 'packages-support-message' }}>
    <Columns collapseBelow="tablet" space="xlarge" alignY="center" reverse>
      <Column>
        <Box className={styles.imageFrame}>
          <img src={supportImage} alt="" className={styles.image} />
        </Box>
      </Column>

      <Column>
        <Stack space="large">
          <Stack space="small">
            <Heading level="2" align={{ mobile: 'center', tablet: 'left' }}>
              Support throughout your selling journey
            </Heading>

            <Text align={{ mobile: 'center', tablet: 'left' }}>
              From how to value your business to how to position it with buyers,
              we’ve got guidance to help you sell sooner.
            </Text>
          </Stack>

          <Inline
            space="none"
            align={{ mobile: 'center', tablet: 'left' }}
            collapseBelow="tablet"
          >
            <ButtonLink
              tone="formAccent"
              variant="ghost"
              href={createDotNetLinkUrl(Routes.SELLING_A_BUSINESS)}
            >
              Get selling advice
            </ButtonLink>
          </Inline>
        </Stack>
      </Column>
    </Columns>
  </Box>
);
